export default {"src":"/_next/static/media/two_small_persons.be011a9c.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};